import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import moment from 'moment';
import { Table, TableBody, TableCell, TableHead, TableRow, Button, Paper } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { STableLoader } from '../../../shared_elements/loaders';
import { PageLoader, EmptyCollection } from '../../../shared_elements';
import { checkApiStatus, getLocalStorageInfo, downloadFileType, onCheckPermission } from '../../../utils_v2';
import { displayDateFormat } from '../../../constants';
import { globalGetService, globalExportService } from '../../../utils_v2/globalApiServices';
import { trackActivity } from '../../../utils/mixpanel';
import DeploymentMessage from '../../../shared/components/DeploymentMessage';
import SaveAltIcon from "@material-ui/icons/SaveAlt"

const OprTracker = ({}) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(true);
    const [oprReport, setOprReport] = useState([]);
    useEffect(() => {
        getOprReport('skeletonLoader');
        trackActivity('Project Management', {
            event_type: 'Page Visited',
            page_title: 'Opr Tracker',
        });
    },[]);
    const getOprReport = (loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true):setLoading(true);
        globalGetService(`technical/project/opr/report/fleet-level/`)
        .then(response => {
            if(checkApiStatus(response)){
                setOprReport(response.data.data);
            }
            loaderType === 'skeletonLoader' ? setSkeletonLoader(false):setLoading(false);
        })
    }
    const exportOprReport = (extension='xls') => {
        enqueueSnackbar('OPR Report Downloading ...', { variant: 'info',anchorOrigin:{horizontal:'right', vertical:'bottom'}})
        globalExportService(`technical/project/opr/report/fleet-level/`, {download:'xls',type:'gantt'})
        .then(response => {
            downloadFileType(response, `OPR_Report_${getLocalStorageInfo().defaultLessor.name}_${moment().format('YYYY-MM-DD')}.`, 'xls');
            closeSnackbar();
            enqueueSnackbar('OPR Report Downloaded', { variant: 'success',anchorOrigin:{horizontal:'right', vertical:'bottom'}})
            trackActivity('Project Management', {
                event_type: 'Item Exported',
                page_title: 'Opr Tracker',
                file_extension: 'xls',
                file_name: `OPR_Report_${getLocalStorageInfo()?.defaultLessor?.name}_${moment().format('YYYY-MM-DD')}`
            });
        })
    }
    return(
        <section className='projects-management-section'>
            <DeploymentMessage />
            <Paper square style={{ padding: '8px 16px' }}>
                <div style={{display:'flex'}}>
                    { skeletonLoader ?
                        ( onCheckPermission('project_management','opr_report','EXP') ?
                            <Skeleton variant="rect" animation='wave' width={88} height={30} style={{marginLeft:'auto', borderRadius:4}} />:null
                        ) :
                        ( onCheckPermission('project_management','opr_report','EXP') && oprReport.length ?
                            <Button style={{marginLeft:'auto'}} onClick={exportOprReport} color='primary' variant='outlined' size='small'> <SaveAltIcon style={{ fontSize: '1.15rem' }}/>Export</Button>:null
                        )
                    }
                </div>
            </Paper>
            {skeletonLoader ? <STableLoader count={9}  rowsFill={8} /> :
            <Paper className='portfolio-fbv-table' style={{ maxHeight: (window.innerHeight - 145) + 'px', overflow: 'auto' }}>
                    <div>
                        {oprReport.length ?
                            <Table className='outer-table'>
                                {(()=>{
                                    let minDate = moment(moment.min(oprReport.filter(item => item.next_inspection_window_lower).map(date => moment(date.next_inspection_window_lower))));
                                    let maxDate = moment(moment.max(oprReport.filter(item => item.next_inspection_window_upper).map(date => moment(date.next_inspection_window_upper))));
                                    let betweenMonths = [];
                                    if (minDate < maxDate){
                                        let date = minDate.startOf('month');
                                        while (date < maxDate.endOf('month')) {
                                            betweenMonths.push(date.format('MMM-YY'));
                                            date.add(1,'month');
                                        }
                                    }
                                    return(
                                        <>
                                            <TableHead className='outer-head'>
                                                <TableRow>
                                                    <TableCell component="th" padding="none" className='child-one'><div style={{width:'140px'}}>Lessee/Operator</div></TableCell>
                                                    <TableCell component="th" padding="none" className='child-two'><div style={{width:'140px'}}>Inspection Date</div></TableCell>
                                                    <TableCell component="th" padding="none" className='child-three'><div style={{width:'140px'}}>OPR Score <span style={{fontSize:'11px'}}>(out of 100)</span></div></TableCell>
                                                    <TableCell component="th" padding="none" className='child-four'><div style={{width:'140px'}}>Inspection By Date</div></TableCell>
                                                    <TableCell component="th" padding="none" className='child-five'><div style={{width:'140px'}}>Inspection Window</div></TableCell>
                                                    { betweenMonths.map((period, monthIndex) => <TableCell key={monthIndex} component="th" padding="none" align='center'><div style={{width:'100px', textAlign:'center'}}>{period}</div></TableCell>)}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody className="outer-body">
                                                {oprReport.map((item, index) =>
                                                    <TableRow key={index}>
                                                        <TableCell component="th" padding="none" className='child-one'>
                                                            <div>{item.operator}</div>
                                                        </TableCell>
                                                        <TableCell component="th" padding="none" className='child-two'>{item.date_of_inspection? moment(item.date_of_inspection).format('MMMM-YY'):'Pending Initial Inspection'}</TableCell>
                                                        <TableCell component="th" padding="none" className='child-three'>{item.total_rating?item.total_rating:'NA'}</TableCell>
                                                        <TableCell component="th" padding="none" className='child-four'>{item.limiting_inspection_date ? moment(item.limiting_inspection_date).format('MMMM-YY'):'--'}</TableCell>
                                                        <TableCell component="th" padding="none" className='child-five'>{item.next_inspection_window_lower ? moment(item.next_inspection_window_lower).format('MMMM-YY'):''} - {item.next_inspection_window_upper ? moment(item.next_inspection_window_upper).format('MMMM-YY'):''}</TableCell>
                                                        {(() => {
                                                            let startIndex = betweenMonths.indexOf(moment(item.next_inspection_window_lower).format('MMM-YY'));
                                                            let endIndex = betweenMonths.indexOf(moment(item.next_inspection_window_upper).format('MMM-YY'))
                                                            if(startIndex === -1 || endIndex === -1){
                                                                return null
                                                            }else{
                                                                return(
                                                                    <>
                                                                        {startIndex !== 0 ? Array(startIndex).fill().map((v,i)=> <TableCell padding="none" key={`pre-${i}`}></TableCell>) :null}
                                                                        <TableCell padding="none" colSpan={endIndex-startIndex+1}>
                                                                            <div style={{background:'#4b903f', height:'20px', width:'100%', borderRadius:'20px'}}></div>
                                                                        </TableCell>
                                                                        {(betweenMonths.length-1) !== endIndex ? Array((betweenMonths.length-1)-endIndex).fill().map((v,i) => <TableCell padding="none" key={`post-${i}`}></TableCell>):null}
                                                                    </>
                                                                )
                                                            }

                                                        })()}
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        </>
                                    )
                                })()}
                            </Table>:null
                        }
                        {oprReport.length === 0 ?<div style={{textAlign:'center', padding:'80px 0'}}><EmptyCollection title='No Record Found'/></div>:null}
                    </div>
            </Paper>
            }
            {isLoading ? <PageLoader/>:null}
        </section>
    )
}
export default OprTracker;
